const HEX_COLOR_PATTERN = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i;

/** 与えられた文字列が "#RGB" または "#RRGGBB" 形式の hex 色かを判定する。 */
export function isValidHexColor(value: unknown): value is string {
  return typeof value === "string" && HEX_COLOR_PATTERN.test(value);
}

/**
 * 色文字列を比較用へ正規化する。hex は大文字小文字・短縮形のゆらぎを吸収する。
 *
 * hex として解釈できない値は正規化せず、そのまま比較する。
 */
export function normalizeColorForCompare(value: string): string {
  return isValidHexColor(value) ? normalizeHexColor(value) : value;
}

/** "#RGB" を "#RRGGBB" に正規化し、両形式でも比較用に小文字へ統一する。 */
export function normalizeHexColor(value: string): string {
  const lowered = value.trim().toLowerCase();
  if (lowered.length === 4) {
    const r = lowered[1] ?? "0";
    const g = lowered[2] ?? "0";
    const b = lowered[3] ?? "0";
    return `#${r}${r}${g}${g}${b}${b}`;
  }
  return lowered;
}
